<div class="grid w-full grid-cols-2 gap-2" *ngIf="!isUsers">
  <label class="btn flex cursor-pointer items-center justify-center" [ngClass]="{ 'bg-dark text-white': filterType === 'None', 'btn-outline-dark': filterType !== 'None' }">
    <input type="radio" name="paymentStatus" class="hidden" [checked]="filterType === 'None'" (click)="filterType = 'None'; onSelectionChangeUnified('None')" />
    {{ "pending" | translate }}
    <span class="badge my-0 bg-white-light text-black ltr:ml-4 rtl:mr-4">{{ total }}</span>
  </label>

  <label class="btn flex cursor-pointer items-center justify-center" [ngClass]="{ 'bg-danger text-white': filterType === 'Rejected', 'btn-outline-danger': filterType !== 'Rejected' }">
    <input type="radio" name="paymentStatus" [(ngModel)]="filterType" value="Rejected" class="hidden" (change)="onSelectionChangeUnified('Rejected')" />
    {{ "rejected" | translate }}
    <span class="badge my-0 bg-white-light text-black ltr:ml-4 rtl:mr-4">{{ rejected }}</span>
  </label>
</div>
<div class="grid w-full grid-cols-2 gap-2" *ngIf="isUsers">
  <label class="btn flex cursor-pointer items-center justify-center" [ngClass]="{ 'bg-dark text-white': filterType === 'Running', 'btn-outline-dark': filterType !== 'Running' }">
    <input type="radio" name="paymentStatus" class="hidden" [checked]="filterType === 'Running'" (click)="filterType = 'Running'; onSelectionChangeUnified('Running')" />
    {{ "instance.active" | translate }}
    <span class="badge my-0 bg-white-light text-black ltr:ml-4 rtl:mr-4">{{ total }}</span>
  </label>

  <label class="btn flex cursor-pointer items-center justify-center" [ngClass]="{ 'bg-danger text-white': filterType === 'Stopped', 'btn-outline-danger': filterType !== 'Rejected' }">
    <input type="radio" name="paymentStatus" [(ngModel)]="filterType" value="Stopped" class="hidden" (change)="onSelectionChangeUnified('Stopped')" />
    {{ "contract.filter_by_stopped" | translate }}
    <span class="badge my-0 bg-white-light text-black ltr:ml-4 rtl:mr-4">{{ rejected }}</span>
  </label>
</div>
